import msudenver from '@/assets/logos/msudenver.svg';
import ucdenver from '@/assets/logos/ucdenver.png';
import ccd from '@/assets/logos/ccd.png';
import ahec from '@/assets/logos/ahec.png';
import msudenverReversed from '@/assets/logos/msudenver-reversed.png';
import ucdenverReversed from '@/assets/logos/ucdenver-reversed.svg';
import ccdReversed from '@/assets/logos/ccd-reversed.png';
import ahecReversed from '@/assets/logos/ahec-reversed.png';

// Each file is the institution's own mark as its brand office publishes it:
// the standard version for light surfaces and the reversed version for dark
// ones. Brand standards forbid recoloring or redrawing these, so a replacement
// comes from the same source: MSU Denver's Marketing Toolkit, CU Denver's
// Brandfolder, CCD's Brand Resources page, and Auraria Campus's Brand &
// Identity page. Keyed like INSTITUTIONS, and a key added there needs a pair
// here, which the InstitutionLogo test enforces.
export const INSTITUTION_LOGOS = Object.freeze({
    light: Object.freeze({ msudenver, ucdenver, ccd, ahec }),
    dark: Object.freeze({
        msudenver: msudenverReversed,
        ucdenver: ucdenverReversed,
        ccd: ccdReversed,
        ahec: ahecReversed,
    }),
});
